var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRectangle75(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 186,
    height: 174,
    viewBox: "0 0 186 174",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M186 174L186 -1.52588e-05L80 -1.06254e-05C35.8172 -8.69409e-06 -6.04016e-06 35.8172 -4.10887e-06 80L0 174L186 174Z",
    fill: "#F4A807"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRectangle75);
export default __webpack_public_path__ + "static/media/Rectangle 75.e9473e8dd900b455af3a11258a53c1c4.svg";
export { ForwardRef as ReactComponent };